import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { SelectValueAccessorDirective, ValidateDirective } from '@skylab-angular-shared/ui';
import { FiscalDevicePaymentMethodsParametersMappingModelWrapper } from '../../fiscal-device-dialog-grid-item';

@Component({
    selector: 'skl-fiscal-device-dialog-grid-payment-method-id',
    template: `
    <ins-form-field
        class="no-boundary grid-cell-ins-component">
        <ins-select
            display-text="name"
            [converter]="entity.paymentMethodsConverter"
            [placeholder]="'scenes.configuration.shared.fiscalization.dialog.grid.columns.system-payment-method.placeholder' | translate"
            [(ngModel)]="entity.model.paymentMethodId"
            [sklValidate]="'paymentMethodId.' + entity.model.sun">
            <ins-option
                [value]="null">
                {{'ui.placeholders.empty' | translate}}
            </ins-option>
            @for (item of entity.paymentMethods; track item) {
                <ins-option
                    [value]="item">
                    {{item.name}}
                </ins-option>
            }
        </ins-select>
    </ins-form-field>`,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [SelectValueAccessorDirective, FormsModule, ValidateDirective, TranslatePipe]
})
export class FiscalDeviceDialogGridPaymentMethodId {
    @Input() public entity!: FiscalDevicePaymentMethodsParametersMappingModelWrapper;
}
